import { render } from "./LoanApplication.vue?vue&type=template&id=4bd41a3a&scoped=true"
import script from "./LoanApplication.vue?vue&type=script&lang=js"
export * from "./LoanApplication.vue?vue&type=script&lang=js"

import "./LoanApplication.vue?vue&type=style&index=0&id=4bd41a3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4bd41a3a"

export default script
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer});
